export default "__VITE_ASSET__RRfbgBWi__"